/* eslint-disable jsx-a11y/anchor-is-valid */
/* See the TODO below */
import React, { Fragment, Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import ActionCountModal from './ActionCountModal';
import FooterLink from './FooterLink';

class ResponsiveFooter extends Component {
  state = {
    actionCountModalIsOpen: false,
  }

  handleOpenModal = () => {
    this.setState({ actionCountModalIsOpen: true });
  }

  handleRequestClose = () => {
    this.setState({ actionCountModalIsOpen: false });
  }

  render = () => {
    const {
      actions,
      actionBankSize,
      history,
      subtabs,
    } = this.props;
    const { actionCountModalIsOpen } = this.state;

    const current = history.location.pathname;


    const myselfPath = `/${subtabs.myself}`;
    const myselfHighlightAlso = subtabs.myself === 'myself' ? '/possessions' : '/myself';

    return (
      <Fragment>
        <nav className="footer-xs" aria-hidden="true">
          <ul className="footer-menu" role="menu">
            <FooterLink to="/" title="Story" current={current} className="fl-ico-story" />
            <FooterLink to={myselfPath} title="Myself" className="fl-ico-myself" current={current} highlightAlso={myselfHighlightAlso} />
            <li className="footer-menu__item footer-menu__item--actions">
              {/* TODO: this is targeted by a stupidly specific CSS rule;
              change its type for a11y reasons and it'll choke */}
              <a className="button--link" onClick={this.handleOpenModal}>
                <div className="footer-menu__item--actions" />
                <div>
                  <span className="action__count__item js-action-count">{actions}</span>
                  {' '}
                  /
                  {' '}
                  <span className="action__count__item">{actionBankSize}</span>
                </div>
              </a>
            </li>
            <FooterLink to="/bazaar" title="Bazaar" className="fl-ico-bazaar" current={current} />
            <FooterLink to="/messages" title="Messages" className="fl-ico-message" current={current} />
          </ul>
        </nav>
        <ActionCountModal
          isOpen={actionCountModalIsOpen}
          onRequestClose={this.handleRequestClose}
        />
      </Fragment>
    );
  };
}

ResponsiveFooter.propTypes = {
  actions: PropTypes.number.isRequired,
  actionBankSize: PropTypes.number.isRequired,
  subtabs: PropTypes.shape({
    myself: PropTypes.string.isRequired,
  }).isRequired,
};

const mapStateToProps = ({ actions, subtabs}) => ({
  subtabs,
  actions: actions.actions,
  actionBankSize: actions.actionBankSize,
});

export default withRouter(connect(mapStateToProps)(ResponsiveFooter));